export default "__VITE_ASSET__BM64WeEa__"